import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  customVariables: ['../sass/variables.scss'],
  theme: {
    typography: {
      letterSpacing: '0.0.5em'
    },
    options: {
      customProperties: true
    },

    overrides: {
      VTextField: {
        label: {
          fontSize: '13px !important'
        }
      }
    },
    themes: {
      light: {
        'font-family': 'Noto Sans KR',
        'input--outline-color': '#4caf50'
      },
      dark: {
        'font-family': 'Noto Sans KR'
      }
    }
  }
})
